<div class="modal-wrapper">
	<div class="top qo-flex-col-center-center qo-padding-hor50 qo-padding-ver20">
		<h4>{{'PUNCH_USER.CREATE_PASSWORD' | translate}}</h4>
	</div>

	<form
		[formGroup]="form"
		class="center qo-flex-col-top-center qo-padding-hor50 qo-padding-ver20"
	>
		<div class="description qo-margin-bottom20">{{'PUNCH_USER.CREATE_PASSWORD_DESCRIPTION' | translate}}</div>

		<div class="qo-form-row qo-margin-bottom20">
			<qo-form-block
				[label]="'PUNCH_USER.CREATE_PASSWORD_DIGITS' | translate"
			>
				<input
					class="qo-input"
					type="text"
					formControlName="pin"
					placeholder="{{'LOGIN.PASSWORD' | translate}}"
					inputmode="numeric"
					[textMask]="{mask: pinMask}"
					(keyup.enter)="punch()"
				>
			</qo-form-block>
		</div>


		<qo-profile-image
			class="qo-margin-bottom20"
			[letter]="user.getInitials()"
			[size]="60"
			[fontSize]="24"
			[imageUrl]="user.profile_picture ? user.profile_picture.download_url : undefined"
		></qo-profile-image>

		<qo-input-checkbox
			[label]="'PUNCH_USER.PASSWORD_DISCLAIMER' | translate"
			class="qo-margin-bottom25"
			formControlName="confirmation"
		></qo-input-checkbox>

		<button
			class="punch-button qo-button-standard qo-primary qo-margin-bottom15"
			(click)="punch()"
			[disabled]="!pinValid || !confirmationValid"
		>{{(punchedIn ? 'PUNCH_USER_MODAL.PUNCH_OUT' : 'PUNCH_USER_MODAL.PUNCH_IN') | translate}}</button>

		<button
			class="qo-button-small qo-grey qo-margin-bottom10"
			(click)="closeModal()"
		>{{'cancel_all' | translate}}</button>
	</form>

	<div class="bottom qo-flex-col-center-center">
		<div class="date">{{date}}</div>
	</div>
</div>
